import { useFetchAttributes } from "@/users/useUserAttributes";
import useGetUser from "@/users/v3/useGetUser";

const computeDatadogUserProperties = ({
  active_licenses: activeLicenses,
  classroom_ids: classroomIds,
  classroom_subject_grades: classroomSubjectGrades,
  district_ids: districtIds,
  grade_level: gradeLevel,
  in_district_with_all_advisory_content: inDistrictWithAllAdvisoryContent,
  is_authenticated: isAuthenticated,
  is_demo: isDemo,
  is_staff: isStaff,
  preferred_school_id: preferredSchoolId,
  school_ids: schoolIds,
  state,
  teacher_subjects: teacherSubjects,
  user_id: userId,
} = {}) => ({
  activeLicenses,
  classroomIds,
  classroomSubjectGrades,
  districtIds,
  gradeLevel,
  inDistrictWithAllAdvisoryContent,
  isAuthenticated,
  isDemo,
  isStaff,
  preferredSchoolId,
  schoolIds,
  state,
  teacherSubjects,
  userId,
  id: userId,
});

const useDatadogUserProperties = () => {
  const { userAttributes } = useFetchAttributes();
  const { data: user } = useGetUser();

  return {
    ...computeDatadogUserProperties(userAttributes),
    roles: user?.roles,
  };
};

export default useDatadogUserProperties;
